import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  window.addEventListener("popstate", cb);
  return () => {
    listeners.delete(cb);
    window.removeEventListener("popstate", cb);
  };
}

/** Client-side navigation. Falls back to a full load for external URLs. */
export function navigate(to: string, opts?: { replace?: boolean }) {
  if (/^https?:\/\//.test(to)) {
    window.location.href = to;
    return;
  }
  if (opts?.replace) window.history.replaceState({}, "", to);
  else window.history.pushState({}, "", to);
  window.scrollTo(0, 0);
  emit();
}

export function usePath(): string {
  return useSyncExternalStore(
    subscribe,
    () => window.location.pathname,
    () => "/",
  );
}

/** Intercepts clicks so <Link> behaves like an anchor but stays in the SPA. */
export function linkProps(to: string) {
  return {
    href: to,
    onClick: (e: React.MouseEvent) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      navigate(to);
    },
  };
}
